import { render, staticRenderFns } from "./EditCustomMapping.vue?vue&type=template&id=edd194f6&"
import script from "./EditCustomMapping.vue?vue&type=script&lang=js&"
export * from "./EditCustomMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports